const ContentSequenceItemTypes = Object.freeze({
  PROGRESSION_GATE: 'progression gate',
  FLOW: 'flow',
})

export { ContentSequenceItemTypes }